<p-dialog [(visible)]="visible" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'1025px': '100vw', '640px': '100vw'}" [style]="{width: '45vw'}" styleClass="no-header-modal overflow-visible" aria-label="change-client-rep-dialog">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <!-- Header -->
    <div
      class="p-3 flex align-items-center justify-content-between relative border-bottom-1 border-300" aria-label="dialog-header">
      <h2 class="mb-0 text-sm" aria-label="dialog-title">{{'CLIENT_PROFILE.CHANGE_CLIENT_REP' | translate}} </h2>
      <i class="fa fa-times text-xl text-600 cursor-pointer" (click)="closeDialogEvent()"  data-testid="close-dialog"></i>
    </div>
    <!-- Header -->

    <!-- Header -->
    <div class="p-3 flex align-items-center border-bottom-1 border-300" aria-label="client-list-header">
      <div class="w-full md:flex align-items-center justify-content-between" aria-label="client-chips">
          <p-chip styleClass="mr-2 bg-primary text-sm pl-0 h-2rem" *ngFor="let client of clients | slice:0:3;" [removable]="false" aria-label="client-chip">
            <p-avatar *ngIf="client.image; else noContactPic" [image]="client.image" styleClass="p-chip-image" shape="circle" aria-label="client-avatar">
              <img class="m-0" [src]="client.image" alt="Image" />
            </p-avatar>
            <ng-template #noContactPic>
            <p-avatar [label]="client.name | titlecase | shortName" shape="circle" styleClass="p-chip-image" aria-label="client-avatar-initials"></p-avatar>
            </ng-template>
            <span class="p-chip-text ml-2 white-space-nowrap overflow-hidden text-overflow-ellipsis w-6rem" aria-label="client-name">{{client.name}}</span>
          </p-chip>
        <div (click)="showAllMembers=true" *ngIf="clients.length > 3"
          class="mt-2 md:mt-0 text-primary font-bold text-sm cursor-pointer md:text-right text-left flex align-items-center" aria-label="show-more-clients" data-testid="show-more-clients">{{clients.length - 3}} {{'SALE_REPRESENTATIVE.MORE' | translate}} 
          <i class="fa fa-chevron-down ml-2" data-testid="show-more-icon"></i>
        </div>
      </div>
    </div>
    <!-- Header -->

    <form [formGroup]="updateClientRepFormGroup" (ngSubmit)="updateClientRepresentative()" aria-label="update-rep-form">
    <!-- Content -->
    <div class="surface-50 text-sm p-3 border-bottom-1 border-300" aria-label="new-rep-section">

        <label class="text-600 text-xs mb-1 block uppercase" aria-label="new-rep-label">{{'SALE_REPRESENTATIVE.NEW_SALES_REP' | translate}}</label>

        <staff-selector [formGroup]="updateClientRepFormGroup" [controlName]="NewRepresentative"
        [canRepresetative]="isClientRepresentative" [claims]="claims" [styleClass]="'w-full text-sm py-0 align-items-center'" aria-label="staff-selector">
       </staff-selector>

    </div>
    <!-- Content -->

    <!-- Modal Footer -->
    <div class="p-3 flex align-items-center justify-content-between" aria-label="dialog-footer">
          <p-button type="button" [label]="'SALE_REPRESENTATIVE.CANCEL' | translate" styleClass="p-button-link text-sm" (click)="closeDialogEvent()" aria-label="cancel--button"></p-button>
          <p-button type="submit" styleClass="text-sm" [disabled]="!updateClientRepFormGroup.valid" [label]="'SALE_REPRESENTATIVE.UPDATE_SALES_REP' | translate"
          [loading]="isloading" aria-label="update-button">
        </p-button>
    </div>
    <!-- Modal Footer -->

    </form>

  </ng-template>

</p-dialog>

<p-dialog [(visible)]="showAllMembers" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'1025px': '100vw', '640px': '100vw'}" [style]="{width: '29vw'}"
  styleClass="no-header-modal no-overflow-content" aria-label="all-members-dialog">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">


    <div
      class="p-3 flex align-items-center justify-content-between relative border-bottom-1 border-300" aria-label="members-dialog-header">
      <div class="flex align-items-center mr-3">
        <i class="fa fa-plus text-600 mr-3" aria-label="plus-icon"></i>
        <h2 class="mb-0 text-sm" [innerHTML]="'SALE_REPRESENTATIVE.LIST_OF_CLIENTS' | translate : {count:clients.length}" aria-label="members-title"></h2>
      </div>
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="showAllMembers = false" aria-label="close-members-dialog" data-testid="close-members-dialog"></div>
    </div>
    <!-- Header -->

    <!-- Header -->
    <div class="p-3 flex align-items-center surface-50 relative border-bottom-1 border-300" aria-label="search-section">
      <div class="p-inputgroup inline-flex w-full mb-3 md:mb-0">
        <span class="p-inputgroup-addon"><i class="fa fa-search text-500" aria-label="search-icon"></i></span>
        <input type="text" class="text-sm" pInputText [placeholder]="'SALE_REPRESENTATIVE.SEARCH_CLIENTS' | translate"  [(ngModel)]="clientsearch" aria-label="search-input"/>
      </div>
    </div>
    <!-- Header -->

    <!-- Content -->
    <div class="surface-50 text-sm py-2 border-bottom-1 border-300" aria-label="members-list-section">

      <p-scrollPanel styleClass="w-full h-25rem" aria-label="members-scroll-panel">
        <div class="flex align-items-center my-2 px-4" *ngFor="let client of clients | clientfilter: clientsearch" aria-label="member-item">
          <p-avatar *ngIf="client.image; else noContactPic" [image]="client.image"  shape="circle" aria-label="member-avatar">
          </p-avatar>
          <ng-template #noContactPic>
          <p-avatar [label]="client.name | titlecase | shortName" shape="circle" aria-label="member-avatar-initials"></p-avatar>
          </ng-template>
          <strong class="text-primary ml-2" aria-label="member-name">{{client.name}}</strong>
        </div>
      </p-scrollPanel>
    </div>
    <!-- Content -->
    
  </ng-template>

</p-dialog>


